import { Pressable, PressableProps } from 'react-native';
import { Text, ITextProps } from '@/components/gluestack/text';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';
import { ReactNode } from 'react';

interface IActionLinkProps extends PressableProps {
  children: ReactNode;
  size?: ITextProps['size'];
}

export function ActionLink({ children, onPress, size, ...props }: IActionLinkProps) {
  const isLargeScreen = useIsLargeScreen();

  return (
    <Pressable
      className="-my-1 rounded-full px-2 py-1 active:bg-background-100"
      hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      onPress={onPress}
      {...props}>
      <Text size={size} className={`text-typography-500 ${isLargeScreen ? 'web:hover:underline' : ''}`}>
        {children}
      </Text>
    </Pressable>
  );
}
